import axios from 'axios'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { sendErrorLog } from '@/api/chatApi'
import { showToast } from '@nutui/nutui'

const http = axios.create({
  baseURL: 'https://ma.chatbot.bayer.cn/service',
  timeout: 20000,
})
http.interceptors.request.use((config) => {
  if (!config.headers) {
    Reflect.set(config, 'headers', {})
  }
  let token = sessionStorage.getItem('token')
  token && config.headers.set('Authorization', `token ${token}`)
  return config
})

http.interceptors.response.use(
  (resp) => {
    if (!resp.status) {
      recordRequestError(resp, undefined)
      return Promise.reject(resp)
    }
    switch (resp.status) {
      case 200:
        return resp.data
      default: {
        recordRequestError(resp, undefined)
        return Promise.reject(resp)
      }
    }
  },
  (error) => {
    if (error.message.startsWith('timeout')) {
      showToast.text('哎呀，网络信号飞到天外啦，可以再试一下吗？')
    } else {
      recordRequestError(undefined, error)
    }
    return Promise.reject(error.message)
  }
)

function recordRequestError(response: AxiosResponse | undefined, error: any) {
  let data
  let url
  let originalMessage

  if (error) {
    url = error.request.chobitsuRequest.url
    if (error.request.chobitsuRequest.method == 'POST') {
      data = error.config.data
    }
    originalMessage = error.message + ';response:' + JSON.stringify(error.response?.data)
  }

  if (response) {
    url = response.request.chobitsuRequest.url
    if (response.request.chobitsuRequest.method == 'POST') {
      data = response.config.data
    }
    originalMessage = response.data
  }

  if (url.includes('errorlog')) {
    return
  }

  let index = url.indexOf('/api/')
  let path = url.substring(index)

  let errorMessage = `path:${path}; postData:${data}; message:${originalMessage}`
  sendErrorLog('', '', 'UNKNOWN_CATEGORY', errorMessage)
}

export function getAction(
  url: string,
  query: AxiosRequestConfig['params'],
  config: AxiosRequestConfig
) {
  return http.request({
    url,
    method: 'GET',
    params: query,
    ...config,
  })
}

export function postAction(
  url: string,
  data: AxiosRequestConfig['data'],
  config: AxiosRequestConfig
) {
  return http.request({
    url,
    method: 'POST',
    data: data,
    ...config,
  })
}
